<template>
  <div class="form-field font-field">
    <label>行高</label>
    <div class="content">
      <el-select :value="style.lineHeight" @input="setLineHeight" placeholder="请选择行高" size="mini">
        <el-option
          v-for="item,index in list"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  import style from 'mixins/style'

  export default {
    mixins: [ style ],
    data() {
      return {
        list: [ 0.5, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.5, 3.0 ],
        value: null
      }
    },
    computed: {
      style() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ] && this.$store.state.mask[ 0 ].style || {}
      },
      mask() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ]
      }
    },
    methods: {
      resizeText(id){
        this.$store.commit('resize_element_complete', {
          id: id
        })
        this.$store.commit('set_mask', {
          id: id
        })
      },
      setLineHeight(value) {
        var id = this.mask.id
        this.updateStyle('lineHeight', value)
        this.$nextTick(() => {
          this.resizeText(id)
        })
      }
    }
  }
</script>
